import React, { useState, useEffect, useCallback } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import style from './ChangePassword.module.css';
import ToastPopup from '../../../../components/comm/ToastPopup';

import { getIsDpAuthCheckPwd, setDpAuthChangePassword } from '../../../../assets/js/comm';

import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import AlertBox from '../../../../components/box/AlertBox';
import URL from '../../../../constants/url';
import { useNavigate } from 'react-router-dom';

const ChangePassword = () => {

    const navigate = useNavigate();

    const [isAlertOpen, setIsAlertOpen] = useState(false);
      
    const [alertText, setAlertText ] = useState("");

    const handleOnAlertClose = () => {
        setIsAlertOpen(false);
    };

    const [isAlertOpen2, setIsAlertOpen2] = useState(false);
      
    const [alertText2, setAlertText2 ] = useState("비밀번호가 일치하지 않습니다.\n다시 확인해주세요.");

    const handleOnAlertClose2 = () => {
        setIsAlertOpen2(false);
    };

    const loginUser = JSON.parse(sessionStorage.getItem('loginUser'));
    const TEST_PASSWORD = 'test1234!'; // 임시 현재 비밀번호

    const [step, setStep] = useState(1);
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [pwView, setPwView] = useState(false);
    const [rePwView, setRePwView] = useState(false);

    const [currentPassword, setCurrentPassword] = useState('');
    const [password, setPassword] = useState('');
    const [rePassword, setRePassword] = useState('');
    const [showRePassword, setShowRePassword] = useState(false);

    const [isChange, setIsChange] = useState(null);

    const [pwRules, setPwRules] = useState({
        length: false,
        number: false,
        letter: false,
        special: false,
    });

    const [currentPwError, setCurrentPwError] = useState(false);

    const handlePwView = () => setPwView(!pwView);
    const handleRePwView = () => setRePwView(!rePwView);

    const handleCurrentPasswordChange = (e) => {
        setCurrentPassword(e.target.value);
        setCurrentPwError(false); // 에러 초기화
    };

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);
        setPwRules({
            length: value.length >= 9,
            number: /\d/.test(value),
            letter: /[a-zA-Z]/.test(value),
            special: /[!@#$%^&*(),.?":{}|<>]/.test(value),
        });
    };

    const handleRePasswordChange = (e) => {
        setRePassword(e.target.value);
    };

    const isPasswordValid = Object.values(pwRules).every(Boolean);
    const isRePasswordValid = password && password === rePassword;

    const handleNext = () => {
        passwordVerify();
    };

    const handleSubmit = () => {
        changePassword();
        // if (isPasswordValid && isRePasswordValid) {
        //     setToastMessage('비밀번호가 변경 되었습니다');
        //     setToast(true);
        // }
    };

    useEffect(() => {
        if (Object.values(pwRules).every(Boolean)) {
            setShowRePassword(true);
        } else {
            setShowRePassword(false);
        }
    }, [pwRules]);

    const passwordVerify = useCallback(() => {

        getIsDpAuthCheckPwd( loginUser.usrUid, currentPassword)
        .then( (res) => {
            console.log( "  ====> handleOnConfirm getIsDpAuthCheckPwd res : ", res );
            if(res) {
                setStep(2);
            } else {
                setCurrentPwError(true);
                setIsAlertOpen2(true)
            }
        })
        .catch( (err) => {
            console.log( " ====> handleOnConfirm getIsDpAuthCheckPwd error : ", err );
            setToastMessage("문제가 발생하였습니다. 관리자에 문의해주세요.");
            setToast(true);
        })

        // const url = "/setting/password/verify";
        // const jToken = localStorage.getItem('jToken');
        // const reqOptions = { headers: { Authorization: jToken } };

        // axiosApi.post(url, {usrPswd : currentPassword}, reqOptions)
        // .then((res) => {
        //     if (res.data.resultCode === CODE.RCV_SUCCESS) {
        //         console.log(res.data.result.policyList)
        //     } else {
        //         // setToastMessage(res.data.resultMessage);
        //         // setToast(true);
        //     }
        // })
        // .catch(err => {
        //     console.error("현재 비밀번호 확인 중 오류 : ", err);
        // })
    },[loginUser, currentPassword])

    const changePassword = useCallback(() => {

        const usrInfo = {
            usrId : loginUser.usrId,
            usrPswd : currentPassword,
            newPswd : password
        }

        setDpAuthChangePassword( usrInfo, setIsChange)

        // const url = "/setting/password/verify";
        // const jToken = localStorage.getItem('jToken');
        // const reqOptions = { headers: { Authorization: jToken } };

        // axiosApi.post(url, {usrPswd : currentPassword}, reqOptions)
        // .then((res) => {
        //     if (res.data.resultCode === CODE.RCV_SUCCESS) {
        //         console.log(res.data.result.policyList)
        //     } else {
        //         // setToastMessage(res.data.resultMessage);
        //         // setToast(true);
        //     }
        // })
        // .catch(err => {
        //     console.error("현재 비밀번호 확인 중 오류 : ", err);
        // })
    },[loginUser, currentPassword, password, rePassword])

    useEffect(() => {
        if(isChange != null) {
            if(isChange?.status === 200) {
                chagePassword();
            } else {
                setToastMessage(isChange?.response?.data?.message || '문제가 발생하였습니다. 관리자에 문의해주세요.');
                setToast(true);
            }
        }
    },[isChange]);

    const chagePassword = useCallback(() => {
        const url = "/setting/password/change";
        const jToken = localStorage.getItem('jToken');
        const reqOptions = { headers: { Authorization: jToken } };

        axiosApi.post(url, {usrPswd : password}, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setAlertText('비밀번호 변경이 완료되었습니다.');
                setIsAlertOpen(true);
            } else {
                setToastMessage('문제가 발생하였습니다. 관리자에 문의해주세요.');
                setToast(true);
            }
        })
        .catch(err => {
            console.error("현재 비밀번호 변경 중 오류 : ", err);
        })
    },[password])

    const goPage = () => {
        navigate(URL.MYINFO_WRITE);
    }


    return (
        <>
            <HeadSub title="비밀번호 변경" />
            <div id="sub-content" data-layout="white">
                <div className="inner-wrap" data-padding="30">
                    <div className={style['content-box']}>
                        <strong className={style['title']}>
                            {/* 비밀번호를 {step === 1 ? '입력' : '설정'}해주세요 */}
                            {step === 1 ? '현재 비밀번호를 입력해주세요.' : '새 비밀번호를 설정해주세요.'}
                        </strong>

                        {/* STEP 1 */}
                        {step === 1 && (
                            <div className={style['input-wrap']}>
                                <span className={style['input-tit']}>현재 비밀번호</span>
                                <div className={style['input-box']}>
                                    <div className={style['pw-box']}>
                                        <input
                                            type={pwView ? 'text' : 'password'}
                                            placeholder="비밀번호를 입력해주세요"
                                            value={currentPassword}
                                            onChange={handleCurrentPasswordChange}
                                        />
                                        <span className={style['line']}></span>
                                    </div>
                                    <button
                                        className={style['pw-view-btn']}
                                        data-view={pwView ? 'on' : 'off'}
                                        onClick={handlePwView}
                                    >
                                        <span className="blind">패스워드 on/off</span>
                                    </button>
                                </div>
                                {/* {currentPwError && (
                                    <div className={style['input-bottom-box']}>
                                        <span className={style['error']}>비밀번호가 일치하지 않습니다</span>
                                    </div>
                                )} */}
                            </div>
                        )}

                        {/* STEP 2 */}
                        {step === 2 && (
                            <>
                                {/* 비밀번호 재입력 */}
                                {showRePassword && (
                                    <div className={style['input-wrap']}>
                                        <div className='animation-2'>
                                            <span className={style['input-tit']}>새 비밀번호 확인</span>
                                            <div className={style['input-box']}>
                                                <div className={style['pw-box']}>
                                                    <input
                                                        type={rePwView ? 'text' : 'password'}
                                                        placeholder="새 비밀번호를 다시 입력해주세요"
                                                        value={rePassword}
                                                        onChange={handleRePasswordChange}
                                                    />
                                                    <span className={style['line']}></span>
                                                </div>
                                                <button
                                                    className={style['pw-view-btn']}
                                                    data-view={rePwView ? 'on' : 'off'}
                                                    onClick={handleRePwView}
                                                >
                                                    <span className="blind">패스워드 on/off</span>
                                                </button>
                                            </div>
                                            <div className={style['input-bottom-box']}>
                                                {rePassword && (
                                                    <span className={isRePasswordValid ? style['on'] : style['error']}>
                                                        {isRePasswordValid
                                                            ? '비밀번호가 일치합니다'
                                                            : '비밀번호가 일치하지 않습니다'}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}


                                {/* 새 비밀번호 */}
                                <div className={style['input-wrap']}>
                                    <span className={style['input-tit']}>새 비밀번호</span>
                                    <div className={style['input-box']}>
                                        <div className={style['pw-box']}>
                                            <input
                                                type={pwView ? 'text' : 'password'}
                                                placeholder="새 비밀번호를 입력해주세요"
                                                value={password}
                                                onChange={handlePasswordChange}
                                            />
                                            <span className={style['line']}></span>
                                        </div>
                                        <button
                                            className={style['pw-view-btn']}
                                            data-view={pwView ? 'on' : 'off'}
                                            onClick={handlePwView}
                                        >
                                            <span className="blind">패스워드 on/off</span>
                                        </button>
                                    </div>
                                    <div className={style['input-bottom-box']}>
                                        <span className={pwRules.length ? style['on'] : ''}>9자리 이상</span>
                                        <span className={pwRules.letter ? style['on'] : ''}>영문</span>
                                        <span className={pwRules.number ? style['on'] : ''}>숫자</span>
                                        <span className={pwRules.special ? style['on'] : ''}>특수문자</span>
                                    </div>
                                </div>

                                
                            </>
                        )}
                    </div>

                    {/* 버튼 */}
                    <div className="bottom-fixed-box">
                        <div className="inner-box">
                            <div className="btn-layout" data-btn-num="1">
                                {step === 1 ? (
                                    <button
                                        className="btn"
                                        data-btn-type="fill-main"
                                        data-btn-size="lg"
                                        onClick={handleNext}
                                        disabled={!currentPassword}
                                    >
                                        <span>다음</span>
                                    </button>
                                ) : (
                                    <button
                                        className="btn"
                                        data-btn-type="fill-main"
                                        data-btn-size="lg"
                                        onClick={handleSubmit}
                                        disabled={!isPasswordValid || !isRePasswordValid}
                                    >
                                        <span>확인</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <AlertBox
                isOpen={isAlertOpen}
                onClose={handleOnAlertClose}
                message={alertText}
                callback={goPage}
                btnTxt='확인'
            />

            <AlertBox
                isOpen={isAlertOpen2}
                onClose={handleOnAlertClose2}
                message={alertText2}
                // callback={goPage}
                btnTxt='확인'
            />

            {/* 토스트 */}
            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                    opacity="90"
                />
            )}
        </>
    );
};

export default ChangePassword;